export const getPartnerDuration = (
  startDate: string,
): { count: number; units: 'years' | 'months' } => {
  const start = new Date(startDate);
  const now = new Date();

  const yearsDiff = now.getFullYear() - start.getFullYear();
  const monthsDiff = now.getMonth() - start.getMonth();
  const daysDiff = now.getDate() - start.getDate();

  let totalMonths = yearsDiff * 12 + monthsDiff;

  // Adjust if the day of the month hasn't been reached yet
  if (daysDiff < 0) {
    totalMonths -= 1;
  }

  if (totalMonths < 12) {
    return { count: Math.max(0, totalMonths), units: 'months' };
  }

  const years = Math.floor(totalMonths / 12);
  return { count: years, units: 'years' };
};
